import { StorageAdapter } from '../platform/types'

export class WebStorageAdapter implements StorageAdapter {
	getItem(key: string): string | null {
		return localStorage.getItem(key)
	}

	setItem(key: string, value: string): void {
		localStorage.setItem(key, value)
	}

	removeItem(key: string): void {
		localStorage.removeItem(key)
	}

	getAllKeys(): string[] {
		const keys: string[] = []
		for (let i = 0; i < localStorage.length; i++) {
			const key = localStorage.key(i)
			if (key) {
				keys.push(key)
			}
		}
		return keys
	}
}
